import { Flex, Text } from '@mantine/core'

import AnimatedPrice from '@/components/AnimatedPrice'
import CoinIcon from '@/components/CoinIcon'
import useCoinPriceChange from '@/hooks/business/useCoinPriceChange'
import { I18nLink } from '@/i18n/navigation'
import { CryptoBasketCoin } from '@/types/invest'

import styles from './styles.module.css'
import useFormatWithSubscript from './useFormatWithSubscript'

export default function TrendingCoin({
  slug,
  symbol,
  livePrice,
}: Pick<CryptoBasketCoin, 'symbol'> & { slug: string; livePrice?: number }) {
  const { coinMarket, percentage, changeColor, changeSymbol } = useCoinPriceChange(slug)
  const coinDetailUrl = `/${slug}`
  const displayPrice = livePrice ?? coinMarket?.usd_price
  const priceFormat = useFormatWithSubscript(displayPrice ?? 0, coinMarket?.app_symbol ?? '')
  if (!coinMarket) return null

  return (
    <I18nLink prefetch={false} href={coinDetailUrl}>
      <Flex className={styles.coinItemContainer} gap={8}>
        <Flex align="center" gap={8}>
          <CoinIcon coin={coinMarket} size={28} />
          <Text variant="body" truncate className={styles.coinSymbol}>
            {symbol}
          </Text>
        </Flex>
        <Flex className={styles.coinRight} gap={0}>
          {priceFormat.hasSubscript ? (
            <Text variant="body-number" truncate>
              {priceFormat.beforeZeros}
              <Text
                component="sub"
                style={{
                  fontSize: '0.786em',
                  verticalAlign: 'baseline',
                  position: 'relative',
                  top: '0.1em',
                }}
              >
                {priceFormat.zeroCount}
              </Text>
              {priceFormat.afterZeros}
            </Text>
          ) : (
            <AnimatedPrice
              variant="body-number"
              price={displayPrice}
              tokenSymbol={coinMarket.app_symbol}
              truncate
            />
          )}
          <Text variant="subtitle" c={changeColor} truncate>{`${changeSymbol}${percentage}`}</Text>
        </Flex>
      </Flex>
    </I18nLink>
  )
}
